import { useEffect } from 'react';
import Head from '../../components/UI/Head/Head';
import { ToastContainer } from 'react-toastify';
import style from './noPage.module.css';

const NoPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main>
      <Head url="/" />
      <div className="container">
        <div className={style.content}>
          <div className="title">
            <h2 className={style.before}>404</h2>
            <span className={style.text}>
              Страница не найдена или идет тех работа
            </span>
          </div>
        </div>
      </div>
      <ToastContainer />
    </main>
  );
};
export default NoPage;
